export default __webpack_public_path__ + "static/media/query.5624075f.png";